<template>
  <div class="dataBoard clearfix">
    <div class="purchase clearfix">
      <div class="title">采购分析</div>
      <div class="table">
        <div class="label" @click="toPurchase" v-if="showMenu('11308')">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>采购报表</span>
            </div>
            <div class="textt item">查看供应商分类采购情况</div>
          </el-card>
        </div>
        <div class="label" @click="toPriceChangeChart" v-if="showMenu('11311')">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>采购价变化趋势</span>
            </div>
            <div class="textt item">查看采购价格变化趋势图</div>
          </el-card>
        </div>
        <div class="label" @click="toPriceChangeChart" v-if="showMenu('11321')">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>供应商单品采购明细表</span>
            </div>
            <div class="textt item">查看供应商单品采购明细表</div>
          </el-card>
        </div>
      </div>
    </div>
    <div class="sale clearfix">
      <div class="title">销售分析</div>
      <div class="table">
        <div class="label" @click="toSalesStatements" v-if="showMenu('11306')">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>销售报表</span>
            </div>
            <div class="textt item">查看项目点产品分类销售情况</div>
          </el-card>
        </div>
        <div class="label" @click="toProductRankList" v-if="showMenu('11313')">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>商品销售排行</span>
            </div>
            <div class="textt item">查看项目点商品销售排行</div>
          </el-card>
        </div>
        <div class="label" @click="toSingleSalesSummary" v-if="showMenu('11318')">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>项目单品销售汇总</span>
            </div>
            <div class="textt item">查看项目点单品销售汇总</div>
          </el-card>
        </div>
        <div class="label" @click="toItemSalesSchedule" v-if="showMenu('11320')">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>项目单品销售明细表</span>
            </div>
            <div class="textt item">查看项目点单品销售明细</div>
          </el-card>
        </div>
        <div class="label" @click="toDeliveryDiscrepancy" v-if="showMenu('11319')">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>送货差异表</span>
            </div>
            <div class="textt item">查看项目点送货差异情况</div>
          </el-card>
        </div>
      </div>
    </div>
    <div class="price clearfix">
      <div class="title">库存分析</div>
      <div class="table">
        <div class="label" @click="toProfitLossTable" v-if="showMenu('11300')">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>盘库盈亏表</span>
            </div>
            <div class="textt item">查看每日盘库盈亏</div>
          </el-card>
        </div>
        <div class="label" @click="toHistoryInStock" v-if="showMenu('11301')">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>历史入库单</span>
            </div>
            <div class="textt item">查看历史入库单</div>
          </el-card>
        </div>
      </div>
    </div>
    <div class="revenue clearfix">
      <div class="title">利润分析</div>
      <div class="table">
        <div class="label" @click="toGrossProfit" v-if="showMenu('11307')">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>毛利表</span>
            </div>
            <div class="textt item">查看产品类别毛利情况</div>
          </el-card>
        </div>
        <div class="label" @click="toTCGrossProfit" v-if="showMenu('11310')">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>客户毛利表</span>
            </div>
            <div class="textt item">查看客户毛利表</div>
          </el-card>
        </div>
        <div class="label" @click="toSingleRange" v-if="showMenu('11314')">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>总仓单品毛利表</span>
            </div>
            <div class="textt item">查看总仓单品毛利表</div>
          </el-card>
        </div>
        <div class="label" @click="toOrderCostGrossProfit" v-if="showMenu('11317')">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>订单成本毛利表</span>
            </div>
            <div class="textt item">查看订单成本毛利表</div>
          </el-card>
        </div>
        <div class="label" @click="toProjectPointGrossProfitTable" v-if="showMenu('11322')">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>项目点单品毛利表</span>
            </div>
            <div class="textt item">查看项目点单品毛利表</div>
          </el-card>
        </div>
        <div class="label" @click="toBusinessGrossProfitTable" v-if="showMenu('11323')">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>业务部毛利表</span>
            </div>
            <div class="textt item">查看业务部毛利表</div>
          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuList: JSON.parse(sessionStorage.getItem('asyncRouterMap')).map((item) => item.MENU_CODE) || [],
    };
  },
  created() {

  },
  methods: {
    // 是否展示菜单
    showMenu(e) {
      return this.menuList.includes(e);
    },
    // 采购退货单
    toReturnProduct() {
      this.$router.push({ path: '/returnProduct' });
    },
    // 采购退货出库单
    toPurchaseReturnStockOut() {
      this.$router.push({ path: '/purchaseReturnStockOut' });
    },
    // 采购报表
    toPurchase() {
      this.$router.push({ path: '/purchase' });
    },
    // 采购价变化趋势
    toPriceChangeChart() {
      this.$router.push({ path: '/priceChangeChart' });
    },
    // 盘库盈亏表
    toProfitLossTable() {
      this.$router.push({ path: '/profitLossTable' });
    },
    // 历史入库单
    toHistoryInStock() {
      this.$router.push({ path: '/historyInStock' });
    },
    // 毛利表
    toGrossProfit() {
      this.$router.push({ path: '/grossProfit' });
    },
    // 客户毛利表
    toTCGrossProfit() {
      this.$router.push({ path: '/TCGrossProfit' });
    },
    // 总仓单品毛利表
    toSingleRange() {
      this.$router.push({ path: '/singleRange' });
    },
    // 订单成本毛利表
    toOrderCostGrossProfit() {
      this.$router.push({ path: '/orderCostGrossProfit' });
    },
    // 项目点单品毛利表
    toProjectPointGrossProfitTable() {
      this.$router.push({ path: '/projectPointGrossProfitTable' });
    },
    // 业务部毛利表
    toBusinessGrossProfitTable() {
      this.$router.push({ path: '/businessGrossProfitTable' });
    },
    // 销售报表
    toSalesStatements() {
      this.$router.push({ path: '/salesStatements' });
    },
    // 销售退库单
    toReturnWarehouse() {
      this.$router.push({ path: '/returnWarehouse' });
    },
    // 销售退货单
    toReturnGoods() {
      this.$router.push({ path: '/returnGoods' });
    },
    // 商品销售排行
    toProductRankList() {
      this.$router.push({ path: '/productRankList' });
    },
    // 项目单品销售汇总
    toSingleSalesSummary() {
      this.$router.push({ path: '/singleSalesSummary' });
    },
    // 项目单品销售明细表
    toItemSalesSchedule() {
      this.$router.push({ path: '/itemSalesSchedule' });
    },
    // 送货差异表
    toDeliveryDiscrepancy() {
      this.$router.push({ path: '/deliveryDiscrepancy' });
    },
  },
};
</script>

<style scoped>
.textt {
  font-size: 14px;
  color: #9c9c9c;
}

.item {
  margin-bottom: 18px;
}

.box-card {
  width: 100%;
  height: 135px;
}

.label {
  width: 19%;
  margin-right: 1.2%;
  margin-bottom: 15px;
}

.label:hover {
  cursor: pointer;
}

.table {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}

.table>.label:nth-child(5n) {
  margin-right: 0;
}

.title {
  margin-bottom: 15px;
}

.dataBoard {
  background-color: white;
  padding: 15px 20px;
}</style>



// WEBPACK FOOTER //
// src/components/tableManage/dataBoard.vue